// extracted by mini-css-extract-plugin
export default {"hamburgerButton":"styles_hamburgerButton__FvBNL","menuText":"styles_menuText__M9Fpl","fullView":"styles_fullView__7agXj","shimmer":"styles_shimmer__wm0Pi"};